import * as React from "react";
import {RouteComponentProps, withRouter} from "react-router";
import Routes from "../../../../../navigation/route/Route";
import * as classNames from "classnames";
import JobBDPChangeNotification from "../../../../../model/notification/assignee/job/JobBDPChangeNotification";

interface IComponentProps {
	/**
	 * Notification for display.
	 */
	notification: JobBDPChangeNotification;
	/**
	 * Mark notification as read.
	 */
	markReadNotification: (notificationId: string) => void;

	/**
	 * Mark notification as unread.
	 */
	markUnreadNotification: (notificationId: string) => void;
}

type Props = IComponentProps & RouteComponentProps<IComponentProps>;

class NotificationJobBDPChangedItem extends React.PureComponent<Props> {
	constructor(props: Props) {
		super(props);
		this.routeToJob = this.routeToJob.bind(this);
	}

	render() {
		const classFromProps = classNames({
			"c-notification": true,
			"active": !this.props.notification.read
		});
		return (
			<div className={classFromProps}>
				<div className={"notification-icon"}>
					<img src="/assets/img/icons/icon-noti-reminder.svg"/>
				</div>
				<div className={"notification-body"}>
					<div className={"notification-header"}>
						Job {this.props.notification.data.getJobReferenceNumber()} &middot;
						Field Service Manager changed
						from {this.props.notification.displayPreviousAssignee()} to {this.props.notification.displayCurrentAssignee()}
					</div>
					<div className={"notification-content"}>
						{this.props.notification.displayCreatorName()}<br/>
						{this.props.notification.displayDate()}
					</div>
					<span className="notification-link" onClick={this.routeToJob}>View</span>
					<span className="notification-link-separator">|</span>
					{this.renderNotificationActions()}
				</div>
			</div>
		);
	}

	/**
	 * Render notification actions.
	 */
	renderNotificationActions() {
		if (this.props.notification.read) {
			return <span className="notification-link"
						 onClick={() => this.props.markUnreadNotification(this.props.notification.id)}>Mark as Unread</span>;
		}
		return <span className="notification-link" onClick={() => this.props.markReadNotification(this.props.notification.id)}>Mark as Read</span>;
	}

	/**
	 * Route to Proper job.
	 */
	routeToJob() {
		this.props.history.push(Routes.EditJob(this.props.notification.data.getJobReferenceNumber()));
	}
}

export default withRouter<IComponentProps>(NotificationJobBDPChangedItem);